import { useCallback } from 'react';

import { validateSubscription } from '@/utils/validateSubscription';

type UseSubscribeReturnType = {
  validateAndProceed: () => Promise<boolean>;
};

const useSubscribe = (): UseSubscribeReturnType => {
  const validateAndProceed = useCallback(validateSubscription, []);

  return { validateAndProceed };
};

export default useSubscribe;
